import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { CommonFunctions } from "../static/common-functions";

 export class VendorReturnBus extends BaseBus
 {
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.insertDt = DateFunctions.getDate(this.insertDt);
         this.updateDt = DateFunctions.getDate(this.updateDt);
         this.creditLinkDt = DateFunctions.getDate(this.creditLinkDt);
         this.returnDate = DateFunctions.getDate(this.returnDate);
         if (CommonFunctions.hasArrayElementValue(this.vendorReturnDetails)) {
             let arr: VendorReturnDetailBus[] = [];
             for (let i = 0; i < this.vendorReturnDetails.length; i++) {
                 let detObj: VendorReturnDetailBus = new VendorReturnDetailBus(this.vendorReturnDetails[i]);
                 arr.push(detObj);
             }
             this.vendorReturnDetails = arr;
         }
     }

     CID(): any {
         return this.vendorReturnId;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
     }

    vendorReturnId: any;
    companyId: any;
    returnDate: Date;
    supplierId: any;
    supplierLocationId: any;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateProvince: string;
    postalCode: string;
    returnTicketNumber: number;
    vendorReturnStatusId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    returnNote: string;
    returnTrackNbr: string;
    returnVendTrackNbr: string;
    vendorCreditId: any;
    ignoreOpenStatus: boolean;
    creditLinkUserId: any;
    ignoreStatusTxt: string;
    creditLinkDt: Date;
    vendorReturnDetails: VendorReturnDetailBus[];
}
